import React, { Component } from 'react';

import { Marker } from 'google-maps-react';

import thunderIconYellow from '../../../images/flashYellow.svg';
import thunderIconRed from '../../../images/flashRed.svg';

class OhlLightingStrikeHitsList extends Component {

    componentDidMount(){
        this.loadOhlLightingStrikeHitsList();
    }

    shouldComponentUpdate(nextProps){
        if (this.props.ohlLightningStrikesList.length !== nextProps.ohlLightningStrikesList.length
            || this.props.showOutageLayer !== nextProps.showOutageLayer
            || this.props.showOhlThunderHitIcons !== nextProps.showOhlThunderHitIcons) {
            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate(){
        this.loadOhlLightingStrikeHitsList();
    }

    loadOhlLightingStrikeHitsList = () => {

        let ohlHitsList = [];

        if (this.props.showOutageLayer && this.props.showOhlThunderHitIcons) {
            this.props.ohlLightningStrikesList.forEach((ohlHit, index) => {
                if (ohlHit.isOutage) {
                    const outageHitMarker =
                        <Marker
                            options={{ icon: { url: thunderIconRed, scaledSize: { width: 20, height: 20 } } }}
                            //options={{ icon: thunderIcon }}
                            key={index}
                            onClick={this.props.onOutageHitClick}
                            position={ohlHit.position}
                            title={'HitTime ' + ohlHit.time + ' OHL: ' + ohlHit.ohl + ' Pole: ' + ohlHit.pole}
                            time={ohlHit.time}
                            ohl={ohlHit.ohl}
                            pole={ohlHit.pole}
                            poleItemIndex={ohlHit.poleItemIndex}
                            stationName={ohlHit.stationName}
                            length={ohlHit.length}
                        />
                    ohlHitsList.push(outageHitMarker)
                }
                else {
                    const ohlHitMarkers =
                        <Marker
                            options={{ icon: { url: thunderIconYellow, scaledSize: { width: 20, height: 20 } } }}
                            key={index}
                            onClick={this.props.onOhlThunderHitClick}
                            position={ohlHit.position}
                            title={'HitTime ' + ohlHit.time + ' OHL: ' + ohlHit.ohl + ' Pole: ' + ohlHit.pole}
                            time={ohlHit.time}
                            ohl={ohlHit.ohl}
                            pole={ohlHit.pole}
                            poleItemIndex={ohlHit.poleItemIndex}
                        />
                    ohlHitsList.push(ohlHitMarkers)
                }
            });
        }
        this.props.sendChildElementDataToState(this.props.stateElementName, ohlHitsList);
        //this.props.getOhlLightningStrikeHitsList(ohlHitsList);
    }


    render() {
        return null;
    }
}

export default OhlLightingStrikeHitsList;